import React from 'react';
import { CheckCircle } from 'react-feather';
import { Card, CardBody } from 'reactstrap';
import dayjs from 'dayjs';

import theme from 'constants/theme';

import { useUnit } from 'hooks/units/index';
import ButtonCompleted from '../../Content/Complete/ButtonCompleted';
import ResultItem from './ResultItem';

const ContentResult = () => {
  const unitSelected = useUnit();

  return (
    <Card style={{ zIndex: 1, marginTop: '3%' }}>
      <CardBody>
        <div className="text-center">
          <CheckCircle size={100} color={theme.success} />
          <p>
            You completed this survey on{' '}
            {dayjs(unitSelected?.createdAt).format('DD/MM/YYYY, HH:mm')}
          </p>
          <ButtonCompleted />
        </div>
        <hr />
        <div>
          {unitSelected?.results?.map((result, index) => (
            <ResultItem
              key={result?._id}
              result={result}
              index={index}
              isEnd={index === unitSelected?.totalSurvey - 1}
            />
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default ContentResult;
